export const AllMaps = {
	"Recharge": {
	"level_id": "c0264785-90c8-4946-bf16-06dbfd056bff",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/recharge.jpg"
  },
	"Live Fire": {
	"level_id": "dc3a5b2a-180a-4544-8bc1-ee4ea1338900",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/live-fire.jpg"
  },
	"Bazaar": {
	"level_id": "1ddfa173-a544-46e6-9dae-671e7e369a0c",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/bazaar.jpg"
  },
	"Behemoth": {
	"level_id": "6cb0eb90-2819-4b6f-a38a-8913a8b91c3e",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/behemoth.jpg"
  },
	"Fragmentation": {
	"level_id": "bead4838-0cff-4837-bcf4-5e516d56d837",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/fragmentation.jpg"
  },
	"Streets": {
	"level_id": "19dfcede-dcd1-45a8-8a77-2b58ce65484f",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/streets.jpg"
  },
	"Launch Site": {
	"level_id": "9755c3a8-5e3c-4352-a78e-370607db660d",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/launch-site.jpg"
  },
	"Aquarius": {
	"level_id": "fc878857-e778-4daf-b0ef-5d826b922f3f",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/aquarius.jpg"
  },
	"Highpower": {
	"level_id": "a17d1839-cab3-4477-ac36-8cbbfaed80cb",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/highpower.jpg"
  },
	"Deadlock": {
	"level_id": "1a8f0677-7055-4358-8c1e-934db988597d",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/deadlock.jpg"
  },
	"Catalyst": {
	"level_id": "dd94dcba-08e9-477d-91b7-338e889305f3",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/catalyst.jpg"
  },
	"Breaker": {
	"level_id": "d4d880b5-59a2-41bd-9c72-70fde4aaaf35",
	"thumbnail_url": "https://etxvqmdrjezgtwgueiar.supabase.co/storage/v1/object/public/assets/games/halo-infinite/metadata/multiplayer/maps/breaker.jpg"
  }
}